export const CONTRACT_TERM_ERROR_MESSAGE =
  'Term must be a number of Days, Months or Years — e.g. "12 Months"';

export const validateContractTerm = (term: string | null): boolean => {
  // Return true if valid
  if (!term) return false;
  const re = /^\d+\s+(day|days|month|months|year|years)$/i;
  return re.test(term);
};
